import { GW_SERVICES_PREFIXES } from 'constants/gateway';
import { API } from 'utils';
import {
  AdditionalServicesDTO,
  PayByNumberInfoDTO,
  ProviderDTO,
  SuccessResponse,
} from './dto';

const { C300, LKZH } = GW_SERVICES_PREFIXES;

export const SendConsultation = (
  data: Record<string, unknown>
): Promise<SuccessResponse> =>
  API.gatewayPost(`/${C300}/public_form/user_contact_us/`, data);

export const SendNewClient = (
  data: Record<string, unknown>
): Promise<SuccessResponse> =>
  API.gatewayPost(`/${C300}/public_form/new_client/`, data);

export const GetProviderByInn = (inn: string): Promise<ProviderDTO> =>
  API.get(`/${C300}/public_provider/search/`, undefined, { inn });

export const GetAdditionalServices = (): Promise<AdditionalServicesDTO[]> =>
  API.get(`/${C300}/public_additional_services/`);

export const GetPayByNumberInfo = (
  params?: Record<string, unknown>
): Promise<PayByNumberInfoDTO> =>
  API.get(`/${LKZH}/public/pay_by_number/`, undefined, params);

export const SendAboutUsMail = (params: { emails: string[] }) =>
  API.gatewayPost(`/${C300}/public/about_us_mail/`, params);
